import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Stack, Typography, Box, Button} from 'views/components';

import {Translate, translate} from 'views/module';

import moment from 'moment';

const RecurrenceReview = (props) => {
  const newEvent = props.newEvent;
  const setIsStepValid = props.setIsStepValid;
  const daysOfWeek = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

  React.useEffect(() => {
    setIsStepValid(true);
  }, []);

  return (
    <Grid container>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.StartDate'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {moment(newEvent.recurrenceData.startDate).format('YYYY-MM-DD')}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.EndDate'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {
              newEvent.recurrenceData.endDate &&
              moment(newEvent.recurrenceData.endDate).format('YYYY-MM-DD')
            }
            {
              !newEvent.recurrenceData.endDate &&
              translate('client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.Infinity')
            }
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.Frequency'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.FrequencyData.${newEvent.recurrenceData.freq}`)}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.Interval'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {newEvent.recurrenceData.interval}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.StartTime'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {moment(newEvent.recurrenceData.startTime).format('hh:mm:ss A')}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.EndTime'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {moment(newEvent.recurrenceData.endTime).format('hh:mm:ss A')}
          </Typography>
        </Stack>
      </Grid>
      {
        (newEvent.breaks.breakDuration > 0 && newEvent.breaks.breakCount > 0) &&
        <>
          <Grid item xs={6}>
            <Stack>
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.Breaks.BreakDuration'/>
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                }}
              >
                <Translate
                  expression="schedule.eventDetail.TimeSection.Minutes"
                  substitute={{breakDuration: newEvent.breaks.breakDuration}}
                />
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack>
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.Breaks.BreakCount'/>
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                }}
              >
                {newEvent.breaks.breakCount}
              </Typography>
            </Stack>
          </Grid>
        </>
      }
      {
        newEvent.recurrenceData.freq === 'WEEKLY' &&
        <Grid item xs={12}>
          <Box >
            {
              daysOfWeek.map((day) => (
                <Button
                  key={day}
                  variant={newEvent.recurrenceData.byweekday.includes(day) ? 'contained' : 'outlined'}
                  sx={{
                    minWidth: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    fontSize: '16px',
                    padding: '0',
                    mr: 1,
                  }}
                >
                  {translate(`client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.DayOfTheWeek.${day}`)}
                </Button>
              ))
            }
          </Box>
        </Grid>
      }
      {
        newEvent.recurrenceData.freq === 'MONTHLY' &&
        <Grid item xs={6}>
          <Stack>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.ByMonthDay'/>
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {newEvent.recurrenceData.bymonthday.join(',')}
            </Typography>
          </Stack>
        </Grid>
      }
      {
        newEvent.recurrenceData.freq === 'YEARLY' &&
        <>
          <Grid item xs={6}>
            <Stack>
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.ByMonth'/>
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                }}
              >
                {newEvent.recurrenceData.bymonth.join(',')}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack>
              <Typography
                sx={{
                  fontWeight: 600,
                }}
              >
                <Translate expression='client.ClientDetail.Scheduling.ScheduleDetail.EventDate.RecurrenceEvent.ByMonthDay'/>
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                }}
              >
                {newEvent.recurrenceData.bymonthday.join(',')}
              </Typography>
            </Stack>
          </Grid>
        </>
      }
    </Grid>
  );
};

RecurrenceReview.propTypes = {
  newEvent: PropTypes.object.isRequired,
  eventType: PropTypes.string.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(RecurrenceReview));
